"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormatSelectorWithMutations = void 0;
exports.FormatSelectorWrapper = FormatSelectorWrapper;
const React = __importStar(require("react"));
const QuantityConversion = __importStar(require("@genesys/shared/lib/quantity-conversion"));
const ScreenAmountProfile = __importStar(require("../screen-amount-profile"));
const format_selector_renderer_1 = require("./format-selector-renderer");
const elements_1 = require("./elements");
const AuthorizationTools = __importStar(require("@genesys/shared/lib/authorization"));
const UserProfile = __importStar(require("../user-profile"));
function FormatSelectorWrapper({ AmountFormatSelector = elements_1.AmountFormatSelectorWithPadding, amountFormat, conversionParameters, fieldGroup, fieldName, propertyType, setState, state }) {
    return (React.createElement(UserProfile.UserProfile, null, user => (React.createElement(ScreenAmountProfile.ScreenAmountProfile, null, ({ deleteAmountFieldFormat, saveAmountFieldFormat, measureSystem, quantityDefaults }) => {
        const onFormatChanged = (unit, decimalCount) => {
            saveAmountFieldFormat(fieldGroup, fieldName, unit, decimalCount);
        };
        const onFormatCleared = () => {
            deleteAmountFieldFormat(fieldGroup, fieldName);
        };
        const onQuantityChange = (quantity) => {
            const quantityDefault = QuantityConversion.getQuantityDefault(quantityDefaults, measureSystem, quantity);
            onFormatChanged(quantityDefault.unit, quantityDefault.decimalCount);
        };
        const title = AuthorizationTools.checkPermission(user.applicationClaims, AuthorizationTools.genesysUserClaims.showFieldDefaultUnits)
            ? "GroupName: " + fieldGroup + "\nFieldName: " + fieldName
            : undefined;
        return (React.createElement("span", { title: title },
            React.createElement(format_selector_renderer_1.FormatSelectorRenderer, { AmountFormatSelector: AmountFormatSelector, conversionParameters: conversionParameters, isQuantitySelectorActive: state.isQuantitySelectorActive, propertyType: propertyType, onFormatChanged: onFormatChanged, onFormatCleared: onFormatCleared, onFormatSelectorActiveChanged: active => {
                    setState({
                        isQuantitySelectorActive: active
                    });
                }, onQuantityChange: onQuantityChange, selectedDecimalCount: amountFormat.decimalCount, selectedUnit: amountFormat.unit, userSelected: amountFormat.userDefined })));
    }))));
}
const initialState = { isQuantitySelectorActive: false };
const formatSelectorWithState = class extends React.Component {
    constructor(props) {
        super(props);
        this.state = initialState;
    }
    render() {
        return (React.createElement(FormatSelectorWrapper, Object.assign({}, this.props, { state: this.state, setState: this.setState.bind(this) })));
    }
};
exports.FormatSelectorWithMutations = formatSelectorWithState;
//# sourceMappingURL=format-selector-with-mutations.js.map